import { defineMessages } from 'react-intl';

export default defineMessages({
  formTitle: {
    id: 'recovery_forgot_password.insert_new_password.title',
  },
  formSubTitle: {
    id: 'recovery_forgot_password.insert_new_password.formSubtitle',
  },
  newPassword: {
    id: 'recovery_forgot_password.insert_new_password.password',
  },
  confirmPassword: {
    id: 'recovery_forgot_password.insert_new_password.confirm_password',
  },
  valid: {
    id: 'recovery_forgot_password.insert_new_password.title_button_valid',
  },
  passwordMsg: {
    id: 'signup_auth_params_security.password_msg',
  },
  confirmPasswordError: {
    id: 'signup_create_password.confirm_password.error',
  },
  requiredField: {
    id: 'required.field',
  },
});
